package com.yogaaicoach.pages.payment

import com.yogaaicoach.common.ui.components.*
import com.yogaaicoach.pages.auth.TokenDataManager
import com.yogaaicoach.pages.payment.ui.SubscriptionPlan
import com.yogaaicoach.pages.payment.ui.SubscriptionViewModel
import com.yogaaicoach.scope
import com.yogaaicoach.user.AppViewModel
import kotlinx.coroutines.launch
import react.ChildrenBuilder
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.p
import react.useEffectOnce
import react.useState
import web.cssom.ClassName

internal external interface SubscriptionPageProps : Props {
    var viewModel: SubscriptionViewModel
    var appViewModel: AppViewModel
    var isCancel: Boolean
    var onNavigateToDashboard: () -> Unit
    var onNavigateToPayment: () -> Unit
    var onNavigateToContactUs: () -> Unit
}

internal val SubscriptionPage = FC<SubscriptionPageProps> { props ->
    var selectedPlan by useState<SubscriptionPlan?>(null)
    var isLoading by useState(false)
    var error by useState<String?>(null)

    useEffectOnce {
        scope.launch { props.viewModel.selectedPlan.collect { selectedPlan = it } }
        scope.launch { props.viewModel.loadingFlow.collect { isLoading = it } }
        scope.launch { props.viewModel.errorFlow.collect { error = it } }
    }

    TopBar {
        title = "Choose Your Plan"
        onSignOut = { props.appViewModel.signOut() }
        onNavigateToDashboard = props.onNavigateToDashboard
        onNavigateToPayment = props.onNavigateToPayment
        onNavigateToContactUs = props.onNavigateToContactUs
    }

    div {
        className = ClassName("payment-page-shell")

        if (props.isCancel) {
            div {
                className = ClassName("payment-status-message payment-status-cancel")
                CancelIconRed {}
                p { +"Your subscription process was cancelled." }
            }
        }

        h2 { className = ClassName("payment-page-title"); +"Choose Your Subscription" }

        val trialDays = TokenDataManager.tokenData?.freeTrialDaysLeft
        if (trialDays != null) {
            p {
                className = ClassName(
                    if (trialDays <= 3) "payment-trial-message payment-trial-warning"
                    else "payment-trial-message"
                )
                +when {
                    trialDays > 3 -> "You have $trialDays days of free trial left."
                    trialDays in 1..3 -> "Your free trial ends in $trialDays ${if (trialDays == 1) "day" else "days"}!"
                    else -> "Your free trial has expired. Please subscribe to continue."
                }
            }
        }

        div {
            className = ClassName("payment-plans")
            PlanCard(SubscriptionPlan.MONTHLY, selectedPlan == SubscriptionPlan.MONTHLY) {
                props.viewModel.onPlanSelected(SubscriptionPlan.MONTHLY)
            }
            PlanCard(SubscriptionPlan.YEARLY, selectedPlan == SubscriptionPlan.YEARLY) {
                props.viewModel.onPlanSelected(SubscriptionPlan.YEARLY)
            }
        }

        error?.let { p { className = ClassName("payment-error"); +it } }

        if (isLoading) {
            div { className = ClassName("payment-loading-spinner") }
        } else {
            val disabled = selectedPlan == null
            button {
                className = ClassName("primary-button${if (disabled) " primary-button-disabled" else ""}")
                this.disabled = disabled
                onClick = { props.viewModel.startSubscription() }
                +"Subscribe"
            }
        }
    }
}

private fun ChildrenBuilder.PlanCard(plan: SubscriptionPlan, isSelected: Boolean, onClick: () -> Unit) {
    div {
        className = ClassName("payment-plan-card${if (isSelected) " payment-plan-card-selected" else ""}")
        this.onClick = { onClick() }
        div {
            className = ClassName("payment-plan-info")
            p { className = ClassName("payment-plan-title"); +plan.title }
            p { className = ClassName("payment-plan-price"); +plan.price }
        }
        if (isSelected) {
            div {
                className = ClassName("payment-plan-check")
                CheckCircleIconGreen {}
            }
        }
    }
}
